module.exports = __webpack_public_path__ + "img/news_nav_back.f7b75239.svg";